export default __webpack_public_path__ + "static/media/chipsCloseIcon.0842d242.svg";